export default __webpack_public_path__ + "static/media/dashboard_received.2936b1d4.svg";